import Cookies from "js-cookie";

const WHATSAPP_NUMBER = process.env.REACT_APP_WHATSAPP_NUMBER || "31997333998";

// Public Key do Mercado Pago — é PÚBLICA por natureza (vai no bundle de qualquer
// forma; o Brick a usa pra tokenizar no navegador). Pode ficar hardcoded como
// fallback: assim o pagamento por cartão não quebra se o .env não for lido no
// build. Usa o .env quando existir (ex.: pra trocar por uma chave TEST- em
// homologação). NUNCA coloque aqui o ACCESS TOKEN — esse é segredo do backend.
export const MP_PUBLIC_KEY =
    process.env.REACT_APP_MP_PUBLIC_KEY || "APP_USR-79b7ce75-281f-4a13-9af1-613f056df6d0";

export const whatsappPhoneOpen = () => {
    window.open(`https://wa.me/${WHATSAPP_NUMBER}`, "_blank");
};

export const getEscolaridadeById = (id) => {
    if (typeof id !== "number") return null;
    const escolaridade = escolaridadeAll.find(item => item.id === id);
    return escolaridade ? escolaridade.name : null;
};

export const escolaridadeAll = [
    { "value": "FUNDAMENTAL_COMPLETO", "name": "Fundamental", "id": 1 },
    { "value": "MEDIO_COMPLETO", "name": "Médio", "id": 3 },
    { "value": "TECNICO_COMPLETO", "name": "Técnico", "id": 12 },
    { "value": "TECNICO_PROFISSIONALIZANTE_COMPLETO", "name": "Técnico profissionalizante", "id": 14 },
    { "value": "SUPERIOR_COMPLETO", "name": "Superior", "id": 5 },
    { "value": "POS_GRADUACAO_COMPLETO", "name": "Pós-graduação", "id": 7 },
    { "value": "ESPECIALIZACAO_COMPLETO", "name": "Especialização", "id": 13 },
    { "value": "MESTRADO_COMPLETO", "name": "Mestrado", "id": 9 },
    { "value": "DOUTORADO_COMPLETO", "name": "Doutorado", "id": 11 },
];

export const escolaridadeAllBack = {
    FUNDAMENTAL_COMPLETO: "Fundamental",
    MEDIO_COMPLETO: "Médio",
    TECNICO_COMPLETO: "Técnico",
    TECNICO_PROFISSIONALIZANTE_COMPLETO: "Técnico profissionalizante",
    SUPERIOR_COMPLETO: "Superior",
    POS_GRADUACAO_COMPLETO: "Pós-graduação",
    ESPECIALIZACAO_COMPLETO: "Especialização",
    MESTRADO_COMPLETO: "Mestrado",
    DOUTORADO_COMPLETO: "Doutorado",
};

// Sugestões de curso pro CursoComboBox: o aluno escolhe da lista OU digita
// o próprio se não encontrar. Mesma lista do gerenciador; ampliar à vontade.
export const CURSOS = [
    'Administração', 'Agronomia', 'Análise e Desenvolvimento de Sistemas',
    'Arquitetura e Urbanismo', 'Biomedicina', 'Ciência da Computação',
    'Ciências Biológicas', 'Ciências Contábeis', 'Ciências Econômicas',
    'Design Gráfico', 'Direito', 'Educação Física', 'Enfermagem',
    'Engenharia Ambiental', 'Engenharia Civil', 'Engenharia de Produção',
    'Engenharia de Software', 'Engenharia Elétrica', 'Engenharia Mecânica',
    'Engenharia Química', 'Estética e Cosmética', 'Farmácia', 'Filosofia',
    'Física', 'Fisioterapia', 'Fonoaudiologia', 'Gastronomia', 'Geografia',
    'Gestão de Recursos Humanos', 'História', 'Jornalismo', 'Letras', 'Logística',
    'Marketing', 'Matemática', 'Medicina', 'Medicina Veterinária', 'Nutrição',
    'Odontologia', 'Pedagogia', 'Psicologia', 'Publicidade e Propaganda',
    'Química', 'Radiologia', 'Redes de Computadores', 'Relações Internacionais',
    'Serviço Social', 'Sistemas de Informação',
    'Técnico em Administração', 'Técnico em Edificações', 'Técnico em Enfermagem',
    'Técnico em Informática', 'Técnico em Segurança do Trabalho',
];

export function formatDateToDDMMYYYY(dateString) {
    if (!dateString) return "";
    const [year, month, day] = dateString.split('-');
    return `${day}/${month}/${year}`;
}

export function capitalizeInitials(text) {
    if (!text) return "";
    return text
        .toLowerCase()
        .split(' ')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
}

export const UEN_TOKEN_KEY = '@UEN:token';
export const UEN_USER_KEY = '@UEN:user';
export const UEN_PIX_KEY = '@UEN:pixData';

// Token, user e pixData ficam todos em localStorage para sobreviverem a:
//   - F5/reload
//   - abrir o link em nova aba (sessionStorage seria zerado)
//   - fechar e reabrir o browser
// Limpeza só acontece em logout explícito ou 401 do backend (axios interceptor).
// Migração: lê do sessionStorage uma única vez por execução pra herdar sessão
// antiga que ainda esteja ativa no momento do deploy.
function migrarTokenLegacy() {
    try {
        const legacy = sessionStorage.getItem(UEN_TOKEN_KEY);
        if (legacy && !localStorage.getItem(UEN_TOKEN_KEY)) {
            localStorage.setItem(UEN_TOKEN_KEY, legacy);
        }
        sessionStorage.removeItem(UEN_TOKEN_KEY);
    } catch {
        /* ambientes sem storage (SSR) — ignora */
    }
}
migrarTokenLegacy();

// Chaves LEGADAS de versões antigas do app que ainda podem estar no navegador
// de quem logou antes da migração pro namespace '@UEN:'. O Header decide se está
// logado lendo localStorage "user" (state.auth) — se essas não forem limpas, o
// usuário continua "logado" depois do Sair e NÃO CONSEGUE SAIR. removeItem em
// chave inexistente é no-op, então é seguro listar todas as conhecidas.
const LEGACY_KEYS = ['user', 'token', 'auth', 'temCarteira', 'pixData', 'nome', 'cpf', 'id'];

export function logoutUEN() {
    localStorage.removeItem(UEN_TOKEN_KEY);
    localStorage.removeItem(UEN_USER_KEY);
    localStorage.removeItem(UEN_PIX_KEY);
    LEGACY_KEYS.forEach((k) => {
        localStorage.removeItem(k);
        sessionStorage.removeItem(k);
    });
    sessionStorage.removeItem(UEN_TOKEN_KEY); // garantia anti-resíduo
    Cookies.remove('login');
}

export const removeAllLocalStorage = logoutUEN;

export function getUENUser() {
    try {
        const raw = localStorage.getItem(UEN_USER_KEY);
        return raw ? JSON.parse(raw) : null;
    } catch {
        return null;
    }
}

export function isAuthenticatedUEN() {
    return !!localStorage.getItem(UEN_TOKEN_KEY);
}
